module.exports = __webpack_public_path__ + "img/DSC_0051.35dfab23.jpg";